<mat-dialog-content>
  <div style="display: flex; flex-flow: column">
    <h2 mat-dialog-title>Modifier le fichier texte</h2>
    <div style="display:flex; align-items: center; color:white; background-color: lightblue;margin-bottom:20px;padding: 8px;border-radius: 10px;" *ngIf="error">
      <mat-icon>information</mat-icon><span style="margin-left:8px;">{{error}}</span>
    </div>
    <mat-form-field>
      <textarea [placeholder]="'Votre texte...'" matInput cdkTextareaAutosize [(ngModel)]="note">{{note}}</textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="dialogRef.close()">Annuler</button>
  <button mat-button [disabled]="!note" (click)="onSubmit()">Modifier</button>
</mat-dialog-actions>
